<template>
<div class="yield" :data-route="$route.name">
  <transition name="fade-slow">
    <div class="loader image" :style="`background-image: url('${showIdent}')`" v-if="showIdent" @click="hideIdent">
      <img :src="showIdent" style="opacity: 0; pointer-events: none;" @load="identLoaded" />
    </div>
  </transition>

  <div class="menu size-small" :class="{out:menuOut}">
    <a class="block trigger" href="#" @click.prevent="$store.commit('openMenu')">Menu</a>
    <router-link class="block caption" append v-if="headerArtist" :to="headerArtistUrl">
      Artist {{headerArtist.num|pad}}/52: {{headerArtist.title}}<span class="location">, <span v-if="headerArtist.city">{{headerArtist.city}},</span> {{headerArtist.country}}</span>
    </router-link>
  </div>

  <div class="current-nav size-small" v-if="pageTitle !== 'home'" :class="{out:menuOut}">{{pageTitle}}</div>

  <top-menu></top-menu>

  <div class="view" :data-route="$route.name">
    <router-view></router-view>
  </div>


  <transition name="sheet-fade">
    <button class="close-overlay size-small" @click.prevent="onClickCloseOverlay" v-if="$route.params.artist">Close</button>
  </transition>
  <transition name="sheet">
    <div class="overlay" v-if="$route.params.artist">
      <router-view name="overlay"></router-view>
    </div>
  </transition>

  <bottom-menu v-if="$route.name !== 'atlas'"></bottom-menu>

  <chyron :show="['home', 'program', 'atlas'].includes($route.name)" v-show="['home', 'program', 'atlas'].includes($route.name)" :atlas="$route.name === 'atlas'"></chyron>
</div>
</template>

<script>
import Vue from 'vue'
import _ from 'lodash'

export default Vue.component('App', {
  mounted() {
    window.addEventListener('scroll', this.onScroll)
    window.addEventListener('resize', this.onResize)

    this.showRandomIdent()
    this.onRouteChange()
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.onScroll)
    window.removeEventListener('resize', this.onResize)
  },
  data: () => ({
    showIdent: false
  }),
  watch: {
    '$route'(to, from) {
      this.onRouteChange()
    },
    lockScroll(lock, from) {
      if(lock) {
        document.body.classList.add('prevent-scroll')
      } else {
        document.body.classList.remove('prevent-scroll')
      }
    }
  },
  computed: {
    pageTitle() {
      return (this.$route.name || '').replace(/Artist/, '')
    },
    headerArtist() {
      return this.currentArtist
    },
    headerArtistUrl() {
      if(this.headerArtist) return `artist/${this.headerArtist.slug}`
    },
    currentArtist() {
      return this.$store.getters['artists/currentArtist']
    },
    menuOut() {
      return this.$store.state.scrollDirection === 'down'
    },
    scrolled() {
      return this.$store.getters.scrolled
    },
    lockScroll() {
      return this.$store.getters.lockScroll
    }
  },
  methods: {
    onClickCloseOverlay() {
      this.$router.replace(window.location.pathname.replace(/\/artist\/(.+)/, '') || '/')
    },
    onRouteChange() {
      let overlay = false

      if(this.$route.matched.length) overlay = _.get(this.$route, 'matched[0].components.overlay')
      this.$store.commit('overlayOpen', overlay)
    },
    identLoaded() {
      document.body.classList.add('ident-loaded')

      if(process.env.NODE_ENV === 'development') {
        this.showIdent = false
      } else {
        this.identTimeout = setTimeout(function() {
          this.showIdent = false
        }.bind(this), 4000)
      }
    },
    showRandomIdent() {
      if(this.identTimeout) clearTimeout(this.identTimeout)

      // const idents = ['/static/images/loader-6.gif', '/static/images/loader-7.gif']
      const idents = ['/static/images/loader-4.gif', '/static/images/loader-5.gif']

      this.showIdent = _.first(_.shuffle(idents))
    },
    hideIdent() {
      if(this.identTimeout) clearTimeout(this.identTimeout)

      this.showIdent = false
    },
    onScroll(event) {
      const scrollTop = document.body.scrollTop || document.documentElement.scrollTop
      this.$store.dispatch('scrollTop', scrollTop)
    },
    onResize(event) {
      this.$store.commit('windowHeight', window.innerHeight)
    }
  }
})
</script>

<style lang="scss">
@import '~@/_variables.scss';

@font-face {
  font-family: 'GT America Mono';
  src: url('/static/fonts/GT-America-Mono-Medium.woff');
}

@font-face {
  font-family: 'GT America Mono';
  src: url('/static/fonts/GT-America-Mono-Medium-Italic.woff');
  font-style: italic;
}

@font-face {
  font-family: 'Neue Haas Grotesk';
  src: url('/static/fonts/NHaasGroteskTXStd-65Md.woff');
  font-weight: bold;
}

* {
  margin: 0;
  padding: 0;
  font: inherit;
  box-sizing: border-box;
}

html {
  font-size: 12px;
  @media (max-width: $break-huge) {
    font-size: 10px;
  }
  @media (max-width: $break-small) {
    font-size: 8px;
  }
}

body {
  font-family: $font-sans;
  background: $color-black;
  line-height: 1.2;
  overflow-x: hidden;
  font-weight: bold;
  &:not(.ident-loaded) .yield {
    visibility: hidden;
  }
}

p, pre {
  margin-bottom: 1.2em;
}

a {
  color: inherit;
  text-decoration: none;
  &:hover {
    color: $color-red;
  }
}
p a {
  text-decoration: underline;
  color: $color-red;
  &:hover {
    color: $color-blue;
  }
}

em {
  font-style: italic;
}

.image {
  background-repeat: no-repeat;
  background-size: cover;
}

button {
  cursor: pointer;
  border: none;
  border-radius: 0;
  appearance: none;
  outline: none;
}

pre {
  font-family: monospace;
  white-space: pre-wrap;
}

.prevent-scroll {
  overflow-y: hidden;
}

.fade-leave-active, .fade-enter-active, .fade-slow-active, .fade-slow-enter-active {
  transition: opacity 1s;
  transition-timing-function: $ease;
}
.fade-enter, .fade-leave-to, .fade-slow-enter, .fade-slow-leave-to {
  opacity: 0;
}
.fade-slow-enter-active {
  transition-duration: 0s;
}
.fade-slow-leave-active {
  transition-duration: 3s;
}

.ident-fade-leave-active {
  transition: opacity 1s;
  transition-timing-function: $ease;
}
.ident-fade-enter, .ident-fade-leave-to {
  opacity: 0;
}

.sheet-enter-active, .sheet-leave-active {
  transition: transform 1s;
  transition-timing-function: $ease;
}
.sheet-enter, .sheet-leave-to {
  transform: translateY(100%);
}
.sheet-reverse-enter-active, .sheet-reverse-leave-active {
  transition: transform 1s;
  transition-timing-function: $ease;
}
.sheet-reverse-enter, .sheet-reverse-leave-to {
  transform: translateY(-100%);
}

.sheet-fade-enter-active, .sheet-fade-leave-active {
  transition: transform 1s, opacity 1s;
  transition-timing-function: $ease;
  opacity: 1;
}
.sheet-fade-enter-active {
  transition-delay: 0.25s;
}
.sheet-fade-leave-active {
  transition: opacity 1s;
  transition-duration: 0.25s;
}
.sheet-fade-enter {
  transform: translateY(100%);
  opacity: 0;
}
.sheet-fade-leave-to {
  opacity: 0;
}

.overlay {
  position: fixed;
  top: 0; left: 0;
  bottom: 0; right: 0;
  z-index: 5;
  overflow-y: scroll;
  overflow-x: hidden;
  box-shadow: 0 0 1rem transparentize($color-black, 0.25);
  -webkit-overflow-scrolling: touch;
}

.close-overlay {
  font-family: $font-mono;
  font-weight: normal;
  background: $color-black;
  color: $color-white;
  text-transform: uppercase;
  position: fixed;
  top: 0; left: 0;
  margin: $gutter;
  z-index: 6;
  padding: 1.2rem 0 1rem;
  width: 7rem;
  &:over {
    background: $color-red;
  }
}

</style>

<style lang="scss" scoped>
@import '~@/_variables.scss';

.yield {
  overflow-x: hidden;
}

.menu, .current-nav {
  position: fixed;
  color: $color-white;
  font-family: $font-mono;
  text-transform: uppercase;
  z-index: 4;
  transition: transform 1s $ease;
  font-weight: normal;
  &.out {
    transform: translateY(calc(-100% - #{$gutter * 2}));
  }
}
.current-nav {
  padding: 1.1rem 1.8rem;
  background: $color-black;
  top: $gutter; right: $gutter;
  @media (max-width: $break-small) {
    display: none;
  }
}
.menu {
  top: $gutter; left: $gutter;
  display: flex;

  @media (max-width: $break-small) {
    right: 0;
    top: 0;
    left: 0;
  }
  
  .block {
    padding: 1.1rem 1.8rem;
  }

  .trigger {
    padding-left: 0;
    padding-right: 0;
    width: 7rem;
    text-align: center;
    background: $color-black;
    &:hover {
      color: inherit;
    }
  }

  .caption {
    background: $color-blue;
    margin-right: $gutter;
    @media (max-width: $break-small) {
      white-space: nowrap;
      text-overflow: ellipsis;
      overflow: hidden;
      flex: 1;
      margin-right: 0;
    }
    &:hover {
      color: inherit;
    }
  }
}

@media (max-width: $break-small) {
  .yield[data-route="atlas"] {
    overflow: hidden;
    /deep/ .chyron {
      display: none;
    }
  }
}

.loader {
  position: fixed;
  top: 0; left: 0;
  bottom: 0; right: 0;
  z-index: 8;
  background-color: white;
  background-position: center;
  background-size: cover;
  image-rendering: pixelated;
}
</style>


// WEBPACK FOOTER //
// src/components/app.vue